import Api from "./Api";
export default {
  paginateContract(paginate) {
    return Api().post("/message/contracts", paginate);
  },
  paginate(paginate) {
    return Api().post("/message/logs", paginate);
  },
};
